import * as React from "react";
import { RichTextArea } from "@grandvisionhq/common";
import { compose } from "@grandvisionhq/utils";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
import { useBloomreachRichText } from "../../../../hooks/hooks/use-bloomreach-rich-text.js";
const CmsRichTextDocument = ({ component }) => {
  const { html } = component.getModels();
  const { backgroundColor, textColor } = component.getParameters();
  const richText = useBloomreachRichText(html);
  return /* @__PURE__ */ React.createElement("div", { className: "rich-text-wrapper", "data-t": "rich-text-wrapper" }, /* @__PURE__ */ React.createElement(RichTextArea, { content: richText, backgroundColor, textColor }));
};
const CmsRichTextDocument$1 = compose(withBreakpointVisibility, withAnchor)(CmsRichTextDocument);
export {
  CmsRichTextDocument,
  CmsRichTextDocument$1 as default
};
//# sourceMappingURL=RichTextDocument.js.map
